import axios from "axios";
import { sendRequestDotNet } from "../../../../../_utils/Axios";

export const CUSTOMERS_URL = "api/internationalCalls";

// READ
export function getAllInternationalCalls() {
  return axios.get(CUSTOMERS_URL);
}

// Method from server should return QueryResultsModel(items: any[], totalsCount: number)
// items => filtered/sorted result
export function findInternationalCalls(queryParams) {
  return sendRequestDotNet(`CallRates/International`,  queryParams );
}
